import { render, staticRenderFns } from "./TemplateBookingUpBox.vue?vue&type=template&id=68390644&"
import script from "./TemplateBookingUpBox.vue?vue&type=script&lang=js&"
export * from "./TemplateBookingUpBox.vue?vue&type=script&lang=js&"
import style0 from "./TemplateBookingUpBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports